module.exports = __webpack_public_path__ + "static/img/kefu_pic.1653c3f0.png";